import { Link } from 'react-router-dom';
import { Breadcrumbs } from '@/components/site/Breadcrumbs';
import { SiteMeta } from '@/components/site/SiteMeta';
import { guides } from '@/content/guides';

function formatDate(iso: string): string {
  const [ano, mes, dia] = iso.split('-');
  return `${dia}/${mes}/${ano}`;
}

export function GuidesIndexPage() {
  return (
    <>
      <SiteMeta title="Guias | Operax" description="Guias sobre a API oficial do WhatsApp." path="/guias" />
      <section className="page-hero">
        <div className="hero-grid-bg" />
        <div className="shell page-hero-in rev">
          <Breadcrumbs items={[{ name: 'Início', path: '/' }, { name: 'Guias' }]} />
          <div className="eyebrow">Guias</div>
          <h1>WhatsApp oficial para empresas, sem enrolação.</h1>
          <p className="lead">
            Quanto custa, como conectar, qual a diferença para o app Business e o que perguntar antes de assinar um
            CRM. Cada guia cita a fonte oficial da Meta.
          </p>
        </div>
      </section>
      <section className="pad">
        <div className="shell">
          <div className="seo-guide-list">
            {guides.map((guide) => (
              <Link key={guide.slug} className="seo-guide-card rev" to={`/guias/${guide.slug}`}>
                <h2>{guide.title}</h2>
                <p>{guide.summary}</p>
                <span className="seo-meta">Atualizado em {formatDate(guide.updated)}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
